import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'primeicons/primeicons.css';
import styles from './UserGroup.module.css';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useUserGroup } from '../../Hooks/Features/Timesheet/useUserGroup.js';
import { useCommon } from '../../Hooks/Common/useCommon.js';
import { SkeletonContainer } from '../Loader/Loader.jsx';
import { MultiSelect } from 'primereact/multiselect';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog.js';

const UserGroup = () => {

  const { checkPermission } = useCommon();
  const { tagRef, setGroupName, selectedUsers, setSelectedUsers, editingGroupId, setEditingGroupId, dialogVisible, setDialogVisible, handleSaveGroup, groupName, groups, handleEditGroup, handleDeleteGroup, handleDeleteUser, handleToggleExpand, confirmDialogVisible, setConfirmDialogVisible, handleConfirmDeleteUser, loader, users } = useUserGroup();

  return (
    <div className="">
      <div ref={() => checkPermission("user group", tagRef)} className='text-right'>
        <button ref={tagRef} id='{"tabname": "user group", "data": "user_group"}' onClick={() => { setGroupName(''); setSelectedUsers([]); setEditingGroupId(null); setDialogVisible(true); }} className="button btn-primary mb-3" >
          <FontAwesomeIcon icon="fa-solid fa-plus"/> Add Group
        </button>
      </div>
      {loader ? <div style={{ height: "100px", width: "20%" }}><SkeletonContainer numSkeletons={2} /></div> :
        <div className="d-flex flex-wrap gap-2" ref={() => checkPermission("user group", tagRef)} >
          {groups?.map((group) => (
            <div key={group?.id} ref={tagRef} id='{"tabname": "user group", "data": "user_group"}' className="w30">
              <div className="card-container" style={{width: "100%"}}>
                <div className="d-flex justify-content-between align-items-center px-2 rounded" style={{backgroundColor: "lightblue"}}>
                  <span className="fw-bold p-1">
                    {group?.group_name} ({group?.users.length})
                  </span>
                  <div className='d-flex gap-2'>
                    <div className='c-pointer' onClick={() => handleEditGroup(group)}><FontAwesomeIcon icon="fa-solid fa-edit"/></div>
                    <div className='c-pointer' onClick={() => handleDeleteGroup(true, group?.id)}><FontAwesomeIcon icon="fa-solid fa-trash"/></div>
                  </div>
                </div>
                <div className={`py-1 ${group?.expanded ? styles.expanded : '' }`} >
                  <ul className="list-group list-group-flush" style={{ fontWeight: '100' }} >
                    {group?.users.slice(0, 3).map((user) => (
                      <li className="d-flex justify-content-between align-items-center p-1" key={user?.id} >
                        <div className='d-flex gap-2 align-items-center'>
                          <img src={`${user?.image_url}?nocache=${Date.now()}`} alt="Profile" height={20} width={20} className="rounded-circle" onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                          <span>{user.name}</span>
                        </div>
                        <div ref={() => checkPermission("user group", tagRef)}>
                          <FontAwesomeIcon ref={tagRef} id='{"tabname": "user group", "data": "user_group"}' icon="fa-solid fa-minus" title="Delete User" onClick={() => handleDeleteUser(group?.id, user.id)} style={{ cursor: 'pointer' }}/>
                        </div>
                      </li>
                    ))}
                    {group?.users.length > 3 && !group?.expanded && (
                      <li className="ms-2 text-primary c-pointer d-flex justify-content-between align-items-center" onClick={() => handleToggleExpand(group?.id)} >Show more...</li>
                    )}
                    {group?.expanded && group?.users.length > 3 && (
                      <>
                        {group?.users.slice(3).map((user) => (
                          <li className="d-flex justify-content-between align-items-center p-1" key={user.id}>
                            <div className='d-flex gap-2 align-items-center'>
                              <img src={`${user?.image_url}?nocache=${Date.now()}`} alt="Profile" height={20} width={20} className="rounded-circle" onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                              <span>{user.name}</span>
                            </div>
                            <div ref={() => checkPermission("user group", tagRef)}>
                              <FontAwesomeIcon ref={tagRef} id='{"tabname": "user group", "data": "user_group"}' icon="fa-solid fa-minus" title="Delete User" onClick={() =>   handleDeleteUser(group?.id, user.id) } style={{ cursor: 'pointer' }} />
                            </div>
                          </li>
                        ))}
                        <li className="ms-2 text-primary c-pointer d-flex justify-content-between align-items-center" onClick={() => handleToggleExpand(group?.id)} > Show less... </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      }

      <Dialog header={editingGroupId ? 'Edit Group' : 'Create New Group'} draggable={false} visible={dialogVisible} onHide={() => setDialogVisible(false)} className='modal-medium'>
        <div>
          <div className="d-flex flex-column">
            <label htmlFor="groupName">Group Name</label>
            <input id="groupName" value={groupName} onChange={(e) => setGroupName(e.target.value)} placeholder="Enter group name" className='input-dd'/>
          </div>
          <div className="">
            <label htmlFor="userSelect">Select Users</label>
            <MultiSelect placeholder='Select Users' options={users?.filtered_users} style={{ height: "auto" }} filter filterInputAutoFocus display='chip' value={selectedUsers} onChange={(e) => { setSelectedUsers(e.target.value); }} optionLabel='user_display_name'/>
          </div>
          <div ref={() => checkPermission("user group", tagRef)} className='mt-1 text-right'>
            <button onClick={() => setDialogVisible(false)} className="button btn-default" >Cancel</button>
            <button className="button btn-primary" onClick={handleSaveGroup} >Save</button>
          </div>
        </div>
      </Dialog>

      <CommanDialog
        visible={confirmDialogVisible?.group ? confirmDialogVisible?.group : confirmDialogVisible?.user}
        handleClose={() => setConfirmDialogVisible((prev) => ({...prev, user: false, group: false, message: "", groupId: null}))}
        message={confirmDialogVisible?.message}
        header="Confirm Delete"
        handleFun={() => {confirmDialogVisible?.group ? handleDeleteGroup(false, confirmDialogVisible?.groupId || 0) : handleConfirmDeleteUser()}}
      />
    </div>
  );
};

export default UserGroup;
